


import { AnimatePresence, motion } from "framer-motion";
// import GenerarActa from "../../../screens/Actas/Acta/Proceso/GenerarActa";
import useMeasure from "react-use-measure";
// import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { Alert, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { Modal, MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useActasStore } from "../../../../store/actasStore";
import { useActas } from "../../../../hooks/useActas";
import { descargarActasImprimirHandler } from "../../../../handlers/actaDetalle.handler";
import { crearPDF } from "./helpers";
import { useActaDetalleStore } from "../../../../store/actaDetalleStore";
import { format, parse, parseISO } from 'date-fns';
import BadgeNumero from "../../../../components/BadgeNumero";
import PrintIcon from "@mui/icons-material/Print";

const ModalImprimirActas2 = ({ actasAImprimir, setActasAImprimir, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads, modals, handlerModal } = useGeneralAppStore();
    const { setActaDetalle } = useActasStore();
    const { acta } = useActaDetalleStore();
    const { imprimirActas } = useActas();
    const [download, setDownload] = useState(false);
    // const { actaDetalle } = useActaDetalleStore()

    // const { acta } = actaDetalle;
    const [ref, bounds] = useMeasure();
    // console.log(loads)
    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "modal_imprimir_actas2" })
        }
    }, [])

    return (


        <>
            <Modal
                backdrop={true}
                show={modals.includes('modal_imprimir_actas2')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "modal_imprimir_actas2" })}
                title={() => "Imprimir Actas"}
            >
                <div className="position-relative">

                    {
                        (loads.includes('marcar_impresa') || loads.includes('descargar_actas')) &&
                        <div className="position-absolute h-100 w-100 z-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <div className=" ">
                        {/* <p className="fs-4 fw-bold">Actas a imprimir</p> */}
                        <div className="mb-0  px-3 pb-5 d-flex flex-column gap-4 overflow-y-scroll mb-2 " style={{ maxHeight: "500px" }}>
                            {
                                actasAImprimir?.map((acta) => {
                                    return (
                                        <React.Fragment key={acta.id}>
                                            <div className="row  " style={{ maxWidth: "500px" }} >
                                                <p className="col-12 col-sm-6 col-md-6 col-lg-5 p-0 m-0 fw-bold"><BadgeNumero estado_id={10} numero={acta?.numero_acta} size={'sm'} /></p>
                                                <p className="col-12 col-sm-6 col-md-6 col-lg-7 p-0 m-0 fw-bold">Patente: <span className="fw-normal "> {acta.plate}</span></p>
                                                {/* <p className="col-12 col-sm-6 col-md-6 col-lg-4 p-0 m-0 fw-bold text-end">Fecha: <span className="fw-normal "> {format(parseISO(acta.fecha_hora,), 'dd/MM/yy HH:mm')}</span></p> */}
                                                {/* {
                                                    acta?.documento &&
                                                    <p className="col-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0 fw-bold">DNI: <span className="fw-normal "> {acta.documento}</span></p>
                                                } */}
                                                {
                                                    acta?.infraccion &&
                                                    <p className="col-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0 fw-bold">Tipo: <span className="fw-normal "> {acta.infraccion}</span></p>
                                                }
                                            </div>

                                        </React.Fragment>
                                    )
                                })
                            }
                        </div>

                    </div>

                    <Alert className="w-100 d-flex flex-column align-items-center gap-3  justify-content-center">
                        <p className="m-0">Primero imprima las actas y luego marquelas como <b>impresa</b>
                        </p>
                        <Button onClick={() => {
                            descargarActasImprimirHandler(actasAImprimir.map(acta => acta.id), setDownload);

                            // console.log(actasAImprimir.map(acta => acta.id))
                        }}>Imprimir actas <PrintIcon /></Button>
                    </Alert>

                    <hr />

                    <section className="w-100 d-flex justify-content-end gap-2">
                        <Button disabled={!download} size="md" onClick={() => { imprimirActas({ actas: actasAImprimir.map((acta) => acta.id), acta_detalle: acta?.id }, setActasAImprimir, setRefetch) }}>Marcar actas impresa</Button>
                        <Button size="md" variant="danger" onClick={() => handlerModal({ modal: false, modalName: "modal_imprimir_actas2" })}>Cancelar</Button>
                    </section>
                    <AnimatePresence>
                        <motion.div animate={{ height: bounds.height }} className="overflow-hidden">
                            estas seguro?
                        </motion.div>
                    </AnimatePresence>
                </div >



            </Modal >
        </>
    );
}
export default ModalImprimirActas2;